import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { isProduction } from '@helpers/misc';

import { preloadStore } from '@store/preload-state';
import { appReducer } from '@reducers/app';
import { uiReducer } from '@reducers/ui';

import { ReduxAction, ReduxPayloadAction } from './types';

export { createSelector as appCreateSelector } from '@reduxjs/toolkit';

/**
 * Actions
 */

export const createReduxAction = <T>(type: T): ReduxAction<T> => {
  return {
    type,
  };
};

export const createReduxPayloadAction = <T, P>(
  type: T,
  payload: P
): ReduxPayloadAction<T, P> => {
  return {
    type,
    payload,
  };
};

/**
 * Reducers
 */

export const rootReducer = combineReducers({
  app: appReducer,
  ui: uiReducer,
});

/**
 * Store
 */

export const createRootStore = () => {
  return configureStore({
    reducer: rootReducer,
    preloadedState: preloadStore(),
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({
        thunk: true,
        immutableCheck: false,
        serializableCheck: false,
      });
    },
    devTools: !isProduction(),
  });
};
